export class Base {
    id: string = '';
}
